import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HTTPCONSTANTS } from '../http/http-constants';
import BlogPost from '../models/blogPost';
import { cleanBlogText } from '../utils/blog-meta';

@Injectable({ providedIn: 'root' })
export class BlogService {
  constructor(private http: HttpClient) {}

  public GetPost(blogHandle: string): Observable<BlogPost> {
    var url = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.apiBaseAddress}/blog/${blogHandle}`;
    return this.http.get<BlogPost>(url).pipe(map((p) => this.clean(p)));
  }

  /** Active posts. On release hosts, only those the build published
   *  (/blog-published.json, written by deploy/release/build-static.mjs);
   *  elsewhere the file is absent and every active post is listed. */
  public GetArticles(): Observable<BlogPost[]> {
    var url = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.apiBaseAddress}/blog`;
    const published = this.http
      .get<string[]>('/blog-published.json')
      .pipe(catchError(() => of(null as string[])));
    return forkJoin([this.http.get<BlogPost[]>(url), published]).pipe(
      map(([posts, handles]) =>
        posts
          .filter((p) => !Array.isArray(handles) || handles.indexOf(p.handle) >= 0)
          .map((p) => this.clean(p))
      )
    );
  }

  private clean(p: BlogPost): BlogPost {
    if (p) p.title = cleanBlogText(p.title);
    return p;
  }
}
